import { getHeaderLogo, getUserContract } from '@/api/user';

const state = {
  logoUrl: '',
  shortName: '',
  manualPath: '',
  icoUrl: '',
  name: '',
  recordInfo: '',
  aiIdentity: '',
  aiLogoUrl: '',
  aiWebsite: '',
  contract: ''
};

const mutations = {
  SET_LOGOURL: (state, data) => {
    state.logoUrl = data.bannerUrl;
    state.shortName = data.shortName;
    state.manualPath = data.manualPath;
    state.icoUrl = data.icoUrl;
    state.name = data.name;
    state.recordInfo = data.recordInfo;
    state.aiIdentity = data.aiIdentity;
    state.aiLogoUrl = data.aiLogoUrl;
    state.aiWebsite = data.aiWebsite;
  },
  SET_CONTRACT: (state, data) => {
    state.contract = data;
  }
};

const actions = {
  getAppName ({ commit }) {
    return new Promise((resolve, reject) => {
      let domainName = window.location.href.split('//')[1].split('/')[0];
      if (domainName.indexOf('localhost') > -1) {
        domainName = 'dev.lontologie.com';
      }
      getHeaderLogo({ address: domainName }).then(response => {
        // 替换网页标签
        var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = response.icoUrl || undefined;
        document.getElementsByTagName('head')[0].appendChild(link);

        commit('SET_LOGOURL', response);
        resolve();
      }).catch(error => {
        console.log(error);
        reject(error);
      });
    });
  },
  getContract ({ commit }) {
    return new Promise((resolve, reject) => {
      getUserContract().then(response => {
        commit('SET_CONTRACT', response.effectiveContract || '');
        resolve();
      }).catch(() => {
        commit('SET_CONTRACT', '');
        resolve();
      });
    });
  }
};

export default {
  namespaced: true,
  state,
  mutations,
  actions
};



// WEBPACK FOOTER //
// ./src/store/modules/app.js